import React from 'react'
import ProductFilterComponent from 'sections/product/fragments/FilterOptions'
import listProductsWithColor from './gql/listProductsWithColor'
import { ReactTableDefaults } from 'react-table'
import { productGrid } from 'sections/category/tableColumns'
import { DataTable } from 'components/DataTable'
import { useTranslation } from 'react-i18next'
import { useDrag } from 'react-dnd'

import { StyledTableCol } from './StyledCategoryTable'

const TableFilter = () => <div className='theme-light'><ProductFilterComponent /></div>

const DragableRow = ({ children, data, className, canDrag, title, style }) => {
	const [, drag] = useDrag({
		item: { type: 'row', ...data },
		canDrag
	})
	return(
		<div title={!canDrag ? title : ''} ref={drag} className={`rt-tr ${className}`} role={'row'} style={style}>
			{children}
		</div>
	)
}

const DragableProductList = ({ categoryId, disableDrag, selectedProductIds, className }) => {
	const [t] = useTranslation()
	return(
		<StyledTableCol>
			<DataTable
				key={`${categoryId}`}
				label={t('category_section.strings.grid_product_list')}
				className={className}
				isInsideContentBlock
				remoteOptions={{
					query: listProductsWithColor,
					withSort: true,
					withFilter: {
						FilterComponent: TableFilter,
						baseFilter: {
							categoryId
						}
					}
				}}
				height={700}
				style={{ minWidth: '300px' }}
				withSearch
				withRowColorTag
				columns={productGrid}
				getTrProps={(state, rowInfo = {}) => ({ data: rowInfo.original })}
				TrComponent={(props) => {
					const isOnGrid = props.data && selectedProductIds.indexOf(props.data.id) !== -1
					return props.data && disableDrag ?
						<ReactTableDefaults.TrComponent {...props} style={isOnGrid ? { background: 'rgba(255, 217, 31, 0.2)' } : {}}/> :
						<DragableRow
							{...props}
							canDrag={!isOnGrid}
							title={t('category_section.strings.already_added')}
							style={isOnGrid ? { background: 'rgba(255, 217, 31, 0.2)' } : {}}
						/>
				}}
			/>
		</StyledTableCol>
	)
}


export default DragableProductList
